const defaultHeaders = {
    'Content-Type': 'application/json'
};
const buildHeaders = (headers) => new Headers(Object.assign(Object.assign({}, defaultHeaders), headers));
export default buildHeaders;
//# sourceMappingURL=buildHeaders.js.map